export default function authHeader(){
  let user = JSON.parse(localStorage.getItem('user'));

  if(user && user.token) {
    return {
      Authorization: 'Bearer ' + user.token,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": process.env.Access_Control_Allow_Origin
    }
  }else return {'Content-Type': "application/json"};
}
